import React from 'react';
import { isPastDueExpectedEndDate } from '../config/projectDates';

function PortfolioSummary({ projects, onMetricClick }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const healthCounts = { 'on track': 0, 'at risk': 0, 'off track': 0 };
  let unspecified = 0;
  let pastDue = 0;
  projects.forEach(project => {
    const health = (project.Project_Health__c || '').trim().toLowerCase();
    if (Object.prototype.hasOwnProperty.call(healthCounts, health)) {
      healthCounts[health]++;
    } else {
      unspecified++;
    }
    if (isPastDueExpectedEndDate(project, today)) pastDue++;
  });

  const metrics = [
    { label: 'Total projects', count: projects.length, className: '', filter: { type: 'clear' } },
    { label: 'On Track', count: healthCounts['on track'], className: 'summary-green', filter: { type: 'health', value: 'On Track' } },
    { label: 'At Risk', count: healthCounts['at risk'], className: 'summary-amber', filter: { type: 'health', value: 'At Risk' } },
    { label: 'Off Track', count: healthCounts['off track'], className: 'summary-red', filter: { type: 'health', value: 'Off Track' } },
    { label: 'Health unspecified', count: unspecified, className: '', filter: { type: 'health', value: 'N/A' } },
    { label: 'Past-due expected end dates', count: pastDue, className: 'summary-red', filter: { type: 'past-due' } },
  ];

  return (
    <section className="portfolio-summary" aria-labelledby="portfolio-summary-title">
      <h2 id="portfolio-summary-title">Portfolio Summary</h2>
      <p>Totals across all projects, independent of active filters</p>
      <div className="portfolio-summary-metrics" role="group" aria-label="Filter projects by portfolio summary">
        {metrics.map(({ label, count, className, filter }) => (
          <button
            key={label}
            type="button"
            className={className}
            aria-label={`${label}: ${count} projects`}
            onClick={() => onMetricClick?.(filter)}
          >
            <span className="portfolio-summary-metric-label">{label}</span>
            <span className="portfolio-summary-metric-count">{count}</span>
          </button>
        ))}
      </div>
    </section>
  );
}

export default PortfolioSummary;
